import React, {useMemo} from 'react';
import {useStyles} from '../../../../../../../shared/hooks/styles';
import {UserCard} from '../userCard';
import {Props} from './model';
import {Platform, View} from 'react-native';
import {Text} from '../../../../../../../shared/components/text';
import {Button} from '../../../../../../../shared/components/button';
import {useIsDesktop} from '../../../../../../../shared/hooks/useIsDesktop';
import {useRegCardState} from '../../../../esiaRegCardState/useRegCardState';
import {useSelector} from 'react-redux';
import {holderProfileSelector} from '../../../../../../../redux/selectors/profile';

export const UserCardList = ({onClose: _onClose, onEsiaSubmit}: Props) => {
  const {kids, parent} = useRegCardState();
  const profile = useSelector(holderProfileSelector());
  const _sortedByValidityKids = (() => {
    return kids.sort((a, b) => {
      return a.errors.length - b.errors.length;
    });
  })();

  const _haveKids = kids?.length > 0 ? true : false;

  const userSelected = useMemo(
    () => kids?.some((kid) => kid?.checked === true) || parent?.checked === true,
    [kids, parent],
  );

  const isDesktopSize = useIsDesktop();
  const styles = useStyles(({theme, isDesktop}) => ({
    modalTitle: {
      paddingTop: 20,
      ...theme.fonts.h3,
    },
    modalWrap: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 0,
      overflow: 'hidden',
      width: 878,
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    contentStyle: {
      paddingTop: 0,
    },
    backButton: {
      marginTop: 16,
    },
    kidsSectionTitle: {
      marginTop: 20,
      marginLeft: 20,
      ...theme.fonts.h3Light,
    },
    btn: {
      marginBottom: userSelected ? (isDesktop ? 40 : 10) : 0,
      width: isDesktop ? 320 : 260,
      textAlign: 'center',
      padding: 6,
      alignSelf: 'center',
      marginTop: 25,
    },
    warningLable: {
      marginBottom: isDesktop ? 40 : 10,
      width: isDesktop ? '80%' : 260,
      textAlign: 'center',
      alignSelf: 'center',
      color: '#F15A59',
      marginTop: 5,
      fontSize: 10,
    },
  }));

  return (
    <View
      testID='modal-showing-userList'
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginHorizontal: 10,
        width: '100%',
      }}>
      {!profile ? (
        <View style={{alignSelf: 'center', width: `75%`}}>
          <UserCard userType={'parent'} />
        </View>
      ) : null}
      {/* {haveKids ? (
        <View style={{alignSelf: 'center', width: `75%`}}>
          <Text style={styles.kidsSectionTitle}>Дети заявителя:</Text>
          {sortedByValidityKids.map((k, kidIndex) => {
            const kidId = kidIndex;
            return (
              <View key={kidIndex} style={{alignSelf: 'center', width: '100%'}}>
                <UserCard key={kidId} userType={'kid'} kidId={kidId} />
              </View>
            );
          })}
        </View>
      ) : null} */}
      <Button
        id='esia_reg_card'
        type='secondary'
        text={isDesktopSize ? 'Оформить нефинансовую карту' : 'Оформить карту'}
        style={styles.btn}
        onPress={onEsiaSubmit}
        disabled={!userSelected}
      />
      {!userSelected ? <Text style={styles.warningLable}>Выберите пользователя для продолжения</Text> : null}
    </View>
  );
};
